module.exports = __webpack_public_path__ + "static/media/filterIcon.88a6a0b7.svg";